<elcia-card>
  <div class="flex h-full min-w-0 flex-col gap-3">

    <!-- The slice cut (by day of month rather than ISO weeks) is what keeps both months aligned when
         they have different lengths; it lives in a tooltip so it costs no vertical space. -->
    <div class="flex min-w-0 items-center gap-2.5">
      <span aria-hidden="true" class="pi pi-chart-bar flex-none text-sm text-[var(--p-surface-400)]"></span>
      <span [title]="'dashboard.chart.slice-hint' | translate"
            class="min-w-0 truncate text-lg font-bold">{{ 'dashboard.chart.time-title' | translate }}</span>
    </div>

    @if (isLoading()) {
      <div class="flex flex-1 items-center justify-center">
        <elcia-loader/>
      </div>
    } @else if (!hasData()) {
      <div class="flex flex-1 items-center justify-center text-sm text-[var(--p-surface-500)]">
        {{ 'dashboard.chart.empty' | translate }}
      </div>
    } @else {
      <div class="min-h-0 flex-1">
        <p-chart [data]="data()" [options]="options()" height="100%" type="bar"/>
      </div>
    }
  </div>
</elcia-card>
